import * as React from 'react';

import { ColorRGB } from '../utils/GlobalHelper';

export interface CoreColorPickerButtonProps {
    buttonColor: ColorRGB;
    activeColor: ColorRGB | null;
    onClick: (value: ColorRGB) => void;
}

export const CoreColorPickerButton: React.StatelessComponent<CoreColorPickerButtonProps> = (props: CoreColorPickerButtonProps) => {
    const colorAsString: string = '#' + props.buttonColor.r.toString(16) + props.buttonColor.g.toString(16) + props.buttonColor.b.toString(16);

    const className: Array<string> = [
        'core-color-picker-button'
    ];

    const onClick: () => void = (): void => {
        props.onClick(props.buttonColor);
    };

    if (
        props.activeColor != null &&
        Math.abs(props.activeColor.r - props.buttonColor.r) <= 5 &&
        Math.abs(props.activeColor.g - props.buttonColor.g) <= 5 &&
        Math.abs(props.activeColor.b - props.buttonColor.b) <= 5
    ) {
        if (
            props.buttonColor.r > 190 &&
            props.buttonColor.g > 190 &&
            props.buttonColor.b > 190
        ) {
            className.push('core-color-picker-button-dark-active');
        } else {
            className.push('core-color-picker-button-active');
        }
    }

    return (
        <div className={className.join(' ')} style={{backgroundColor: colorAsString}} onClick={onClick}/>
    );
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CoreColorPickerButton.tsx